import WarningIcon from "@mui/icons-material/Warning"
import { Typography, useTheme } from "@mui/material"
import { useConfirm } from "material-ui-confirm"

import { CONFIRM_TITLE } from "../../../constants/generalConstants"

/**
 * Reusable helper function to handle confirmation dialogs
 * @param message - The message to display in the confirmation dialog
 * @param title - The title of the confirmation dialog
 * @param onConfirm - The callback function to execute when the user confirms
 */
const useConfirmationDialog = (): {
    handleConfirmation: (message: string, onConfirm: () => void) => void
} => {
    const confirm = useConfirm()
    const theme = useTheme()

    const handleConfirmation = (
        message: string,
        onConfirm: () => void
    ): void => {
        confirm({
            title: (
                <Typography variant="h6" component="div" align="center">
                    {CONFIRM_TITLE}
                </Typography>
            ),
            description: (
                <Typography
                    variant="body1"
                    component="span"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                    }}
                >
                    <WarningIcon
                        sx={{
                            fontSize: "2.5rem",
                            color: theme.palette.warning.main,
                            verticalAlign: "middle",
                            marginRight: "1rem",
                        }}
                    />
                    {message}
                </Typography>
            ),
        })
            .then(onConfirm)
            .catch(() => {
                /* Handle cancellation */
            })
    }

    return { handleConfirmation }
}

export default useConfirmationDialog
